import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
import PersonQuery from '../views/PersonQuery.vue'
import ArticleList from '../views/ArticleList.vue'
import ArticleDetail from '../views/ArticleDetail.vue'
import AboutUs from '../views/AboutUs.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: "/index"
  },
  {
    path: '/index',
    name: 'index',
    component: index
  },
  {
    path: '/person-query',
    name: 'PersonQuery',
    component: PersonQuery,
  },
  {
    path: '/article-list',
    name: 'ArticleList',
    component: ArticleList,
  },
  {
    path: '/article/:id',
    name: 'ArticleDetail',
    component: ArticleDetail,
  },
  {
    path: '/about-us',
    name: 'AboutUs',
    component: AboutUs,
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
